// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-dialog[data-v-0f44127a]{width:300px}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/motoreasy/assets/js/components/Modals/InfoModal.vue"],"names":[],"mappings":"AACI,+BACI,WAAR","sourcesContent":["\n    .modal-dialog {\n        width: 300px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
